import { getUserData } from "@/lib/auth";
import ClientDashboard from "./ClientDashboardSimple";
import ClientDashboardPortal from "./ClientDashboardPortal";

const DashboardRouter = () => {
  const user = getUserData();
  
  // Se for usuário interno (admin), mostra dashboard administrativo
  if (user?.user_type === 'internal') {
    return <ClientDashboard />;
  }
  
  // Se for cliente, mostra dashboard portal
  return <ClientDashboardPortal />;
};

export default DashboardRouter;
